/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_a_whole_new_way: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `A Whole New Way to Yoga`,
    es: `Un nuevo camino al yoga`,
  };
  return phrases[locale] || phrases.en || ``;
};
